import React, { Fragment } from 'react';
import { Parallax } from 'react-scroll-parallax';
import Showcase from '../common/Showcase';
import { ReactSVG } from 'react-svg';
import Media from 'react-media';
import { MOBILE_WIDTH } from '../../constants';
import loop from '../../assets/shapes/processLoop.svg';
import rightBottomArrow from '../../assets/shapes/rightBottomArrow.svg';

import styles from './Reflection.module.scss';
import imageSource from '../../assets/screenshots/6-retroForm.png';
const reflection = {
	title: 'Reflection',
	content:
		'Change is achieved by CONTINUOUS improvement. Reflecting on your previous cycle and identifying what went well and where you can improve will cultivate growth.',
	featureTitle: 'Features',
	features: ['Reflect on areas where you excelled or changes that worked for you.', 'Identify areas where you could be better, perhaps with an idea of what to try differently the next cycle.'],
	imageSource,
};
const { centerCluster, centerStyle, center, centerSM, border, ringStyle, circleStyle, shapeCluster, lead, middle, trail, leadSM, middleSM, trailSM } =
	styles;

const Reflection = (props) => {
	return (
		<Media query={{ maxWidth: MOBILE_WIDTH }}>
			{(matches) => (
				<Fragment>
					<Showcase item={reflection} bubbleStyle={border}>
						<div className={centerCluster}>
							<Parallax offsetYMax={100} offsetYMin={-100} translateY={[100, -100]} className={centerStyle}>
								<ReactSVG src={loop} className={`${matches ? centerSM : center}`} />
							</Parallax>
						</div>

						<Parallax translateX={[-30, 30]} className={`${matches ? leadSM : lead}`}>
							<ReactSVG src={rightBottomArrow} />
						</Parallax>

						<Parallax translateX={[-30, 30]} className={`${matches ? middleSM : middle}`}>
							<ReactSVG src={rightBottomArrow} />
						</Parallax>

						<Parallax translateX={[-30, 30]} className={`${matches ? trailSM : trail}`}>
							<ReactSVG src={rightBottomArrow} />
						</Parallax>
					</Showcase>
				</Fragment>
			)}
		</Media>
	);
};

export default Reflection;
